
/**
 * Composable to insert text at cursor into an input element
 */
export function useTextInsertion(inputRef) {

  //Insert text into input element
  const insertText = textToInsert => {

    //Can't insert if there's no ref (yet)
    if (!inputRef.value) {
      return
    }

    //Get props
    const input = inputRef.value.$el || inputRef.value
    const start = input.selectionStart
    const end = input.selectionEnd
    const textBefore = input.value.substring(0, start)
    const textAfter = input.value.substring(end, input.value.length)

    //Update the input's value and dispatch an input event to
    //trigger changes to the model
    input.value = `${textBefore}${textToInsert}${textAfter}`
    input.dispatchEvent(new Event('input'))

    //Focus after a short timeout
    setTimeout(() => {
      const newPos = start + textToInsert.length
      input.setSelectionRange(newPos, newPos)
      input.focus()
    }, 100)
  }

  //Expose interface
  return {
    insertText,
  }
}
